module.exports = __webpack_public_path__ + "static/media/plus.c32f4433.svg";